module.exports = __webpack_public_path__ + "img/avatar6.14ec9265.png";